class NotificationController {
  constructor() {
    this.name = 'notification';
  }
}

export default NotificationController;



// WEBPACK FOOTER //
// ./client/app/components/notification/notification.controller.js